var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gdpr-page"},[_c('header-comp'),_c('side-bar',{attrs:{"type":"light","width":"fluid"}}),_c('main',[_c('div',{staticClass:"container-fluid"},[_vm._t("default")],2)]),_c('footer-comp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }